// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { invoicesModel } from '@/firebase/firebase-config'

export const RefreshInvoice = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        view_invoice: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        refreshInvoiceHandler: function(invoice_id) {

            try {

                // Get the doc
                invoicesModel.where('id', '==', invoice_id).limit(1).get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Set the doc prop
                    **  @prop_location: @here
                    */

                    snapshot.forEach(doc => {

                        this.view_invoice = doc.data();

                    });

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Refresh Invoice from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'UkIEFPmGwJ6g2byhPvaP',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
               
                this.reportAuthBugsnagError({
                    title: 'Refresh Invoice from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'xASODwSVV1iOr4ApUeyg',
                    error: e
                });

            }

        }

    }

}